import { Path } from 'react-hook-form';
import { BankOfIrelandForm } from '../../queries/schema/carFinance.schema';

export type { StepConfig } from '../shared/types';

export const TOTAL_STEPS = 6;

export const STEP_1_FIELDS: Path<BankOfIrelandForm>[] = [
  'personalDetails.title',
  'personalDetails.firstName',
  'personalDetails.surname',
  'personalDetails.phone',
  'personalDetails.email',
];

export const STEP_2_FIELDS: Path<BankOfIrelandForm>[] = [
  'personalDetails.dateOfBirth',
  'personalDetails.gender',
  'personalDetails.maritalStatus',
  'personalDetails.ppsNumber',
];

export const STEP_3_FIELDS: Path<BankOfIrelandForm>[] = [
  'currentAddress.residentialStatus',
  'currentAddress.addressLine1',
  'currentAddress.town',
  'currentAddress.county',
  'currentAddress.timeAtCurrentAddress.years',
];

export const STEP_4_FIELDS: Path<BankOfIrelandForm>[] = [
  'employmentDetails.status',
  'employmentDetails.occupation',
  'employmentDetails.employerName',
  'employmentDetails.timeWithEmployer.years',
];

export const STEP_5_FIELDS: Path<BankOfIrelandForm>[] = [
  'bankingDetails.income',
  'bankingDetails.monthlyMortgageRent',
  'bankingDetails.bankName',
];
